export class LoginUser {
  static readonly type = '[User] Logging in';
  constructor(public payload: {}) {}
}

export class LogoutUser {
  static readonly type = '[User] Logging out';
  constructor(public payload: {}) {}
}
